import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {Button} from 'primereact/button';
import {ProgressBar} from 'primereact/progressbar';
import CandidateProfileFields from './CandidateProfileSection';
import {candidatePayload} from './candidateProfileSchema';
import {recruitmentApi} from '../recruitmentApi';

const CandidateFormComponent = props => {
  const {t} = props;
  const {id, entity} = useParams();
  const history = useHistory();
  const candidateId = props.candidateId || (!window.App.urlVars().create && window.App.urlVars().candidateId) || (entity === 'candidate' && id);
  const [values, setValues] = useState({active: true, approved: true, general_registration: true});
  const [changed, setChanged] = useState([]);
  const [loading, setLoading] = useState(!!candidateId);
  const [loadFailed, setLoadFailed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (!candidateId) return;
    let active = true;
    setLoading(true); setLoadFailed(false);
    recruitmentApi('get', '/candidate/' + candidateId).then(r => {
      if (active) { setValues(r.data.data); setChanged([]); }
    }).catch(() => { if (active) setLoadFailed(true); }).finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [candidateId]);
  const save = async event => {
    event.preventDefault();
    if (loading || saving || loadFailed) return;
    const back = event.nativeEvent.submitter?.value === 'back' || props.goback;
    const payload = candidatePayload(values, candidateId ? changed : null);
    if (typeof payload.city === 'string') {
      setError(t('candidateProfile.selectCity', {defaultValue: 'Válassz várost a találatok közül.'})); return;
    }
    setSaving(true); setError('');
    try {
      const response = await recruitmentApi(candidateId ? 'patch' : 'post', candidateId ? '/candidate/' + candidateId : '/candidate', payload);
      setValues(response.data.data); setChanged([]);
      window.App.setState({rerenderCandidateList: Math.random(), rerenderCandidateShow: Math.random()});
      window.App.toastShow('success', t('successfulSave', {defaultValue: 'Sikeres mentés!'}));
      if (back) history.push(props.backlink || '/recruitment/candidate');
      else if (!candidateId) history.push('/recruitment/candidate/update/' + response.data.data.id);
    } catch (error) {
      const body = error.response?.data;
      setError(body?.detail || body?.message || t('error'));
      window.App.toastShow('error', t('error'), '', '', error.response);
    } finally { setSaving(false); }
  };
  return <div className="candidate-form widget">
    {loading && <ProgressBar mode="indeterminate" style={{height: 4}}/>}
    {(error || loadFailed) && <p role="alert" className="p-error">{error || t('candidateProfile.loadError', {defaultValue: 'A jelölt betöltése nem sikerült. Frissítsd az oldalt.'})}</p>}
    {!loading && !loadFailed && <form onSubmit={save}>
      <CandidateProfileFields values={values} t={t} disabled={saving} onChange={(name, value) => {
        setValues(previous => ({...previous, [name]: value}));
        setChanged(previous => [...new Set([...previous, name])]);
      }}/>
      <div className="p-text-right">
        <Button type="submit" value="save" label={t('save')} icon="pi pi-save" loading={saving} className="p-button-success p-mr-2"/>
        <Button type="submit" value="back" label={t('saveAndBack')} icon="pi pi-arrow-left" loading={saving} className="p-button-success"/>
      </div>
    </form>}
  </div>;
};
export default withTranslation('common')(CandidateFormComponent);
